export const FIGMA_FILE_KEY = 'figma/fileKey';
export const FIGMA_NODE_IDS = 'figma/nodeIds';
